import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { FullThread } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export const useGetThreadById = ({
    threadId,
    enabled,
}: {
    threadId?: string;
    enabled: boolean;
}): UseQueryResult<Pick<FullThread, "messages">> => {
    return useQuery({
        enabled: !!threadId && enabled && salesSettingsHelper.isSuperAgentEnabled,
        queryKey: aiAgentQueryKeys.superAgent.threadById(threadId ?? ""),
        queryFn: ({ signal }) => {
            return salesApiService.aiAgent.superAgent.getThreadById(
                { threadId: threadId ?? "" },
                { cancellation: signal },
            );
        },
    });
};
